import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import { getPackageDetailsResponses, paymentDetailsResponses } from "../actions";

export function* createOrderEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`razorpay/createOrder`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Razorpay saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* verifyOrderEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`razorpay/verifyOrder`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Razorpay saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}
export function* fetchPaymentEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`/razorpay/fetch/${action?.payload?.paymentId}`)
    );
    action.payload?.callback?.success?.(data);
    yield put(paymentDetailsResponses(data));
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* razorPayWatcherSaga() {
  yield takeLatest(types.CREATE_RAZORPAY, createOrderEffectSaga);
  yield takeLatest(types.CREATE_RAZORPAY, verifyOrderEffectSaga);
  yield takeLatest(types.FETCH_PAYMENT, fetchPaymentEffectSaga);
}
